module.exports = __webpack_public_path__ + "static/media/course_calendar_ru.61c1a8ec.jpg";